<template>
  <div v-if="datacollection && numbers.length" class="vacancy-stat">
    <VacancyStatVisitorsChart
      :chart-data="datacollection"
      :height="50"
    ></VacancyStatVisitorsChart>
  </div>
</template>

<script>
import gql from "graphql-tag";
import moment from "moment";
import VacancyStatVisitorsChart from "./VacancyStatVisitorsChart";

export default {
  components: {
    VacancyStatVisitorsChart
  },
  props: {
    numbers: { type: Array, required: true }
  },
  data() {
    return {
      datacollection: null
    };
  },
  apollo: {
    biStats: {
      query: gql`
        query biStats($filter: BIStatsFilter!) {
          biStats(filter: $filter) {
            interval
            numDatapoints
            datapoints {
              time
              interval
              amount
              type
            }
          }
        }
      `,
      variables() {
        return {
          filter: {
            vacancyNumber: this.numbers,
            interval: 1440,
            fromTime: moment().subtract(3, "days"),
            metrics: ["VISITORS"]
          }
        };
      }
    }
  },
  watch: {
    biStats(stats) {
      if (!stats.datapoints) {
        this.datacollection = null;
        return;
      }

      stats.datapoints.sort((a, b) =>
        a.time > b.time ? 1 : a.time < b.time ? -1 : 0
      );

      let labels = [];
      for (let data of stats.datapoints) {
        let time = moment(data.time);
        if (labels.findIndex(val => val.diff(time) === 0) === -1) {
          labels.push(time);
        }
      }

      let visitorsData = [];
      for (let label of labels) {
        let visitors = 0;
        for (let data of stats.datapoints) {
          let time = moment(data.time);
          if (time.diff(label) === 0 && data.type === "VISITORS") {
            visitors = data.amount;
          }
        }

        visitorsData.push(visitors);
      }

      this.datacollection = {
        labels,
        datasets: [
          {
            borderColor: "#48c6ef",
            data: visitorsData,
            fill: true,
            backgroundColor: "rgba(72, 198, 239, 0.8)",
            lineTension: 0
          }
        ]
      };
    }
  }
};
</script>
